@if (card.state !== CardState.Hidden) {
    <div
        (click)="card.isInteractive && selectCard(card)"
        class="card-placeholder"
        [class.card-placeholder-rotated]="card.isRotated"
        [class.card-placeholder-compact]="card.isCompact"
        [class.interactive]="card.isInteractive"
        [class.disabled]="card.isDisabled"
        [class.card-placeholder-back]="card.state === CardState.Back || card.state === CardState.Checked"
    >
        @if (card.state !== CardState.Empty && card.state !== CardState.Back) {
            @if (card.state === CardState.Show) {
                <app-card [cardValue]="card.value" [rotated]="card.isRotated" [compact]="card.isCompact"></app-card>
                @if (card.isIncorrect) {
                    <div class="text-on-card text-on-card-incorrect" i18n>Incorrect card</div>
                } @else if (card.isCorrected) {
                    <div class="text-on-card text-on-card-corrected" i18n>Corrected card</div>
                }
            } @else if (card.state === CardState.Checked) {
                <div class="card-icon-check"></div>
            } @else {
                <app-card-message
                    i18n
                    [cardState]="card.state"
                    [back]="card.state === CardState.MessageFaceDown"
                    [textOnly]="card.isRotated || card.state === CardState.MessageFlipCard"
                    [compact]="card.isCompact"
                >
                </app-card-message>
            }
        }
    </div>
    @if (card.isCorrected) {
        <button i18n class="button-game button-game-mini" [class.disabled]="card.isDisabled" (click)="revertCardValue(card)">REVERT</button>
    }
}
